import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  // загрузка переводов по HTTP: /locales/{{lng}}/{{ns}}.json
  .use(HttpApi)
  // детектирование языка из браузера / localStorage / cookie / заголовков
  .use(LanguageDetector)
  // подключаем react-хуки
  .use(initReactI18next)
  .init({
    fallbackLng: 'ru',               // язык по умолчанию
    supportedLngs: ['en', 'ru'],
    ns: ['translation'],             // имена namespace’ов
    defaultNS: 'translation',
    // detection: {
    //   order: ['header', 'querystring', 'cookie', 'localStorage', 'navigator'],
    //   caches: ['cookie']
    // },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    react: {
      useSuspense: false             // или true, если хотите Suspense для загрузки
    }
  });

export default i18n;